namespace RedBullMOBILE360.Web.API {
    export namespace eInvoiceService {
        export const baseUrl = '~/api/eInvoice';


        export declare const enum Methods {

        }

    }
}
